import PageHeader from "@/components/PageHeader";
import CapabilitiesSection from "@/components/sections/CapabilitiesSection";
import IndustriesSection from "@/components/sections/IndustriesSection";
import AssessmentCTA from "@/components/sections/AssessmentCTA";
import { Reveal, Eyebrow } from "@/components/primitives";
import { HIDDEN_COSTS } from "@/data/content";

export default function Solutions() {
    return (
        <>
            <PageHeader
                eyebrow="Solutions"
                titleLines={["Capabilities that", "remove repetitive work"]}
                description="We combine a focused set of automation capabilities to eliminate the manual work that slows shipping and logistics operations down."
            />

            <section className="py-24 md:py-28">
                <div className="mx-auto max-w-7xl px-6 lg:px-10">
                    <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
                        <div className="lg:col-span-8">
                            <Reveal>
                                <Eyebrow>Where it hurts today</Eyebrow>
                            </Reveal>
                            <Reveal delay={0.05}>
                                <h2 className="mt-5 max-w-2xl text-balance text-4xl font-bold leading-[1.1] tracking-tight md:text-5xl">
                                    The work we quietly take off your team&apos;s
                                    plate
                                </h2>
                            </Reveal>
                        </div>
                    </div>
                    <div className="mt-12 grid grid-cols-1 gap-x-12 gap-y-8 md:grid-cols-2">
                        {HIDDEN_COSTS.map((c, i) => (
                            <Reveal key={c.title} delay={(i % 2) * 0.06}>
                                <div className="flex gap-5 border-t border-border pt-6">
                                    <span className="font-mono text-sm text-navy">
                                        0{i + 1}
                                    </span>
                                    <div>
                                        <h3 className="text-xl font-semibold tracking-tight">
                                            {c.title}
                                        </h3>
                                        <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground">
                                            {c.body}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <CapabilitiesSection className="border-t" />
            <IndustriesSection />
            <AssessmentCTA />
        </>
    );
}
